let callback = undefined;
let recaptchaValue = undefined;

function showSelectRegionPopup(c, defaultRegion) {
    callback = c;

    if (defaultRegion) {
        $('#select-region-popup select').val(defaultRegion);
    }

    $('#select-region-popup').modal('show');
}

$(document).on('submit', '#select-region-popup .region-popup-form', function(e) {
    e.preventDefault();

    if ($('#zones-list-popup').val() === "") {
        $.growl.warning({
            title: "",
            message: "Please select your area",
            location: "tr",
        });
        return;
    }

    if ($('#select-region-popup #region-popup-organization_name').val() === "") {
        $.growl.warning({
            title: "",
            message: "Please enter your Brokerage/Company name ",
            location: "tr",
        });
        return;
    }

    $('#select-region-popup').modal('hide');
});

$('#select-region-popup').on('hidden.bs.modal', function (e) {
    callback(
        $("#zones-list-popup").val(),
        $('#select-region-popup #region-popup-organization_name').val(),
        recaptchaValue
        // $('#select-region-popup .region-popup-select-user-type:checked').val()
    );
});

function recaptchaCallback(v) {
    recaptchaValue = v;
}

// $(document).on('click', '.region-popup-select-user-type', function () {
//     $('.region-popup-organization-name-container').show();
//     var userType = $(this).val();
//     if (userType=='6') {
//         $('.region-popup-organization_name-label').html('Your Company');
//         $('#region-popup-organization_name').attr('placeholder','Your Company');
//     } else {
//         $('.region-popup-organization_name-label').html('Your Brokerage');
//         $('#region-popup-organization_name').attr('placeholder','Your Brokerage');
//     }
// });

window.showSelectRegionPopup = showSelectRegionPopup;
window.recaptchaCallback = recaptchaCallback;